// src/data/mockData.ts
import { User, Client, Document, Audit, AuditItem } from '../types';

// --- USUARIOS (Para simular login) ---
export const mockUsers: User[] = [
  { 
    id: 'u1', 
    email: 'admin@hrpro.com', 
    name: 'Wendy Reyes', 
    role: 'admin',
    status: 'active',
    phone: '+57 300 1111111',
    createdAt: '2024-01-15T10:00:00Z',
    lastLogin: '2025-11-05T14:30:00Z'
  },
  { 
    id: 'u2', 
    email: 'client@acme.com', 
    name: 'Juan Pérez', 
    role: 'client', 
    status: 'active',
    clientId: 'c1',
    phone: '+57 310 1234567',
    createdAt: '2024-03-20T09:00:00Z',
    lastLogin: '2025-11-04T16:45:00Z'
  },
  { 
    id: 'u3', 
    email: 'client@beta.com', 
    name: 'Ana Gómez', 
    role: 'client', 
    status: 'active',
    clientId: 'c2',
    phone: '+57 320 9876543',
    createdAt: '2024-04-10T11:30:00Z',
    lastLogin: '2025-11-03T10:20:00Z'
  },
  { 
    id: 'u4', 
    email: 'admin2@hrpro.com', 
    name: 'Carlos Rodríguez', 
    role: 'admin',
    status: 'active',
    phone: '+57 315 5555555',
    createdAt: '2024-06-01T08:00:00Z',
    lastLogin: '2025-11-05T09:15:00Z'
  },
  { 
    id: 'u5', 
    email: 'maria@acme.com', 
    name: 'María López', 
    role: 'client',
    status: 'inactive',
    clientId: 'c1',
    phone: '+57 311 2222222',
    createdAt: '2024-07-15T14:00:00Z'
  },
];

// --- CLIENTES ---
export const mockClients: Client[] = [
  { 
    id: 'c1', 
    companyName: 'Acme Corp', 
    nit: '900123456-7',
    sector: 'Tecnología',
    address: 'Calle 100 #15-20, Bogotá',
    contactPerson: 'Juan Pérez', 
    contactEmail: 'juan@acme.com',
    phone: '+57 310 1234567'
  },
  { 
    id: 'c2', 
    companyName: 'Beta Inc', 
    nit: '800987654-3',
    sector: 'Manufactura',
    address: 'Carrera 7 #45-30, Medellín',
    contactPerson: 'Ana Gómez', 
    contactEmail: 'ana@beta.com',
    phone: '+57 320 9876543'
  },
];

// --- DOCUMENTOS ---
export const mockDocuments: Document[] = [
  { id: 'd1', name: 'Reglamento Interno v1.pdf', clientId: 'c1', category: 'Políticas', version: 1, uploadedAt: '2025-08-15T10:00:00Z', uploadedBy: 'u1', fileUrl: '#' },
  { id: 'd2', name: 'Política de Teletrabajo.docx', clientId: 'c1', category: 'Políticas', version: 2, uploadedAt: '2025-09-20T14:30:00Z', uploadedBy: 'u1', fileUrl: '#', previousVersionId: 'd1' },
  { id: 'd3', name: 'Manual de SG-SST.pdf', clientId: 'c2', category: 'Auditorías', version: 1, uploadedAt: '2025-10-03T09:00:00Z', uploadedBy: 'u1', fileUrl: '#' },
  { id: 'd4', name: 'Contrato Colectivo.pdf', clientId: 'c1', category: 'Contratos', version: 1, uploadedAt: '2025-07-10T08:00:00Z', uploadedBy: 'u1', fileUrl: '#' },
  { id: 'd5', name: 'Plan de Emergencias.pdf', clientId: 'c2', category: 'Reportes', version: 1, uploadedAt: '2025-09-05T11:00:00Z', uploadedBy: 'u1', fileUrl: '#' },
  { id: 'd6', name: 'Código de Ética.pdf', clientId: 'c1', category: 'Políticas', version: 1, uploadedAt: '2025-10-22T16:00:00Z', uploadedBy: 'u1', fileUrl: '#' },
];

// --- AUDITORÍAS ---
const auditItems1: AuditItem[] = [
  { id: 'i1', text: 'Verificar contratos de trabajo (Art. 1)', status: 'pending', adminNotes: '' },
  { id: 'i2', text: 'Verificar pagos de seguridad social', status: 'pending', adminNotes: '' },
  { id: 'i3', text: 'Revisar reglamento interno', status: 'compliant', evidenceFile: 'RIT_v1.pdf', adminNotes: 'Revisado OK' },
];

const auditItems2: AuditItem[] = [
  { id: 'i4', text: 'Plan de capacitación anual', status: 'non-compliant', adminNotes: 'No se presenta el plan' },
  { id: 'i5', text: 'Evaluaciones de desempeño', status: 'pending', adminNotes: '' },
];

const auditItems3: AuditItem[] = [
  { id: 'i6', text: 'Verificar nómina', status: 'compliant', adminNotes: 'Conforme', evidenceFile: 'nomina.xlsx' },
];

const auditItems4: AuditItem[] = [
  { id: 'i7', text: 'Revisión de permisos', status: 'compliant', adminNotes: 'OK' },
];

export const mockAudits: Audit[] = [
  { id: 'a1', title: 'Auditoría Laboral Q4 2025', clientId: 'c1', status: 'in-progress', items: auditItems1, createdAt: '2025-10-15T10:00:00Z' },
  { id: 'a2', title: 'Revisión de Talento Humano', clientId: 'c2', status: 'pending', items: auditItems2, createdAt: '2025-10-20T14:00:00Z' },
  { id: 'a3', title: 'Auditoría de Nómina Q3', clientId: 'c1', status: 'completed', items: auditItems3, createdAt: '2025-09-10T09:00:00Z' },
  { id: 'a4', title: 'Revisión SST Agosto', clientId: 'c2', status: 'completed', items: auditItems4, createdAt: '2025-08-05T11:00:00Z' },
  { id: 'a5', title: 'Auditoría Contractual', clientId: 'c1', status: 'completed', items: auditItems1, createdAt: '2025-07-22T10:00:00Z' },
];
